// src/features/billing/use-billing-summary.ts
import { useQuery } from '@tanstack/react-query'

import { useAuth } from '@/features/auth/auth-context'

import { getSubscription, getUsage } from './billing-api'
import { deriveBillingSummary, type BillingSummary } from './billing-summary'

const STALE_TIME = 5 * 60_000

export function useBillingSummary(): BillingSummary & { isLoading: boolean } {
  const { isAuthenticated } = useAuth()

  // meta.silent — не поднимать глобальный error-тост: эти запросы теперь идут на
  // каждой странице (в топбаре), а не только на /billing (см. Step 0 про query-client).
  const usage = useQuery({
    queryKey: ['billing', 'usage'],
    queryFn: () => getUsage(),
    enabled: isAuthenticated,
    staleTime: STALE_TIME,
    meta: { silent: true },
  })
  const subscription = useQuery({
    queryKey: ['billing', 'subscription'],
    queryFn: () => getSubscription(),
    enabled: isAuthenticated,
    staleTime: STALE_TIME,
    meta: { silent: true },
  })

  // isLoading по ОБОИМ запросам: тон/дата/статус зависят от subscription, поэтому
  // чип не должен отрендериться «зелёным» пока подписка ещё грузится.
  return {
    ...deriveBillingSummary(usage.data ?? null, subscription.data ?? null),
    isLoading: usage.isLoading || subscription.isLoading,
  }
}
